import { BaseViewStore, BaasicDropdownStore } from "core/stores";
import { FacilityOrderTemplateNewFlowClinicalEditViewStore } from "application/facility-order-new-flow-clinical/stores";
import { action, observable } from "mobx";
import _ from "lodash";
class FacilityOrderPatientNewFlowClinicalEditViewStore extends BaseViewStore {
    @observable accessor items;
    @observable accessor facilityOrderPatient;
    @observable accessor facilityOrderPatientNote;
    @observable accessor facilityOrderTemplateStores;
    @observable accessor patient = null;
    @observable accessor insuranceInfo = "";
    @observable accessor disabledPatient = false;
    @observable accessor inactiveOptionStoreId = "";
    @observable accessor isDropdownOpen = false;
    inactiveOptions = [{ id: "0", name: "Active" }, { id: "15", name: "Hospital" }, { id: "17", name: "Discharged" }, { id: "18", name: "Expired" }];

    constructor(rootStore, componentsProps) {
        super(rootStore);

        this.rootStore = rootStore;
        this.id = componentsProps.id;
        this.patient = componentsProps.item[0].patient;
        this.pageViewStore = componentsProps.pageViewStore;
        this.facilityOrder = this.pageViewStore.facilityOrder;
        this.isMasterPatient = this.facilityOrder.facility.masterPatientId == this.patient.patientKey;
        this.lookups = this.pageViewStore.lookups;
        this.selectedStatusAbrv = this.pageViewStore.selectedStatusAbrv;
        this.checkIsEmpty = this.pageViewStore.checkIsEmpty;
        this.facilityOrderPatient = componentsProps.facilityOrderPatient;
        this.isImportAllowed = this.pageViewStore.isImportAllowed;

        this.inactiveOptionStore = new BaasicDropdownStore({},
            {
                fetchFunc: () => {
                    return this.inactiveOptions;
                },
            }
        );

        this.fetch([this.initialize(componentsProps.item)]);
    }

    @action.bound
    async initialize(items) {
        await this.initializePatient();
        this.items = _.map(items, item => {
            return {
                ...item,
                itemsVisible: this.selectedStatusAbrv === "in-progress" && (!item.templateId || item.newFlowStatus.abrv === "change") ? true : false,
                isMenuVisible: false
            }
        });

        if (this.items && this.items.some(i => i.templateId)) {
            this.oldTemplate = this.items.filter(i => i.templateId)[0];
        }

        this.facilityOrderTemplateStores = this.items.map(item =>
            new FacilityOrderTemplateNewFlowClinicalEditViewStore(this.rootStore, { item: item, selectedStatusAbrv: this.selectedStatusAbrv, facilityOrderId: this.facilityOrder.id, patient: this.patient, reviewFacilityOrderTemplate: () => this.reviewFacilityOrderTemplate(item.id), fetchPatientTemplates: (isReview) => this.fetchPatientTemplates(null, isReview), lookups: this.lookups, facilityOrder: this.facilityOrder, removeTemplate: (id) => this.removeTemplate(id), setLinkedTemplate: (id) => this.setLinkedTemplate(id), initializePatientHeightAndWeight: () => this.initializePatientHeightAndWeight(), isNewPatient: this.isNewPatient, isEligible: this.isEligible, facilityOrderPatient: this.facilityOrderPatient, checkIsEmpty: (isReview) => this.checkIsEmpty(isReview), getNumberOfTemplates: () => this.getNumberOfTemplates(), isImportAllowed: this.isImportAllowed, diagnosisCode: this.lookups.diagnosisCode, pageViewStore: this.pageViewStore })
        );

        this.getPatientStatusButtonClassName();
        this.enteralItemCategoryId = _.find(this.lookups.itemCategory, s => { return s.abrv === 'enteral'; }).id;
    }

    @action.bound
    initializePatientHeightAndWeight() {
        this.facilityOrderTemplateStores.map(store => {
            store.form.$("height").value = this.patient.height;
            store.form.$("weight").value = this.patient.weight;
        }
        );
    }

    @action.bound
    async fetchPatient() {
        if (this.patient) {
            let response = await this.pageViewStore.localPatientService.get(this.patient.id);
            this.patient = response.data;
        }
    }

    @action.bound
    async initializePatient(fetchData = false) {
        if (fetchData) {
            var response = (await this.pageViewStore.facilityOrderPatientService.find({ facilityOrderId: this.facilityOrder.id, patientId: this.patient.id, embed: "EligibilityStatus,FacilityOrderPatientInitial,FacilityOrderPatientInitial.EligibilityStatus", })).data.item;
            if (response && response[0]) {
                Object.keys(this.facilityOrderPatient).forEach(key => {
                    this.facilityOrderPatient[key] = response[0][key];
                });
            }
        }
        this.facilityOrderPatientNote = this.facilityOrderPatient && this.facilityOrderPatient.note;
        this.isEligible = this.facilityOrderPatient && this.facilityOrderPatient.eligibilityStatus && this.facilityOrderPatient.eligibilityStatus.name === "Eligible";
        this.isNewPatient = this.facilityOrderPatient && this.facilityOrderPatient.isNewPatient;
        this.insuranceInfo = this.facilityOrderPatient && this.facilityOrderPatient.insuranceInfo;
    }

    @action.bound
    async fetchPatientTemplates(ids, isReview) {
        this.disabledPatient = true;
        await this.initializePatient(true);
        this.items = await this.pageViewStore.fetchFacilityOrderTemplatesByPatient(this.id, ids);

        if (!(this.items && this.items.some(i => i.id)) && this.facilityOrderTemplateStores) {
            this.facilityOrderTemplateStores = undefined;
            this.checkIsEmpty(isReview);
            return;
        }

        this.items = _.map(this.items, (i) => { return { ...i, itemsVisible: i.inactiveReasonId === 58 || (this.selectedStatusAbrv === "in-progress" && (!i.templateId || i.newFlowStatus.abrv === "change")) ? true : false}; });
        if (this.items && this.items.some(i => i.templateId)) {
            this.oldTemplate = this.items.filter(i => i.templateId)[0];
        }
        this.facilityOrderTemplateStores = this.items.map(item =>
            new FacilityOrderTemplateNewFlowClinicalEditViewStore(this.rootStore, { item: item, selectedStatusAbrv: this.selectedStatusAbrv, facilityOrderId: this.facilityOrder.id, patient: this.patient, reviewFacilityOrderTemplate: () => this.reviewFacilityOrderTemplate(item.id), fetchPatientTemplates: (isReview) => this.fetchPatientTemplates(null, isReview), lookups: this.lookups, facilityOrder: this.facilityOrder, removeTemplate: (id) => this.removeTemplate(id), setLinkedTemplate: (id) => this.setLinkedTemplate(id), initializePatientHeightAndWeight: () => this.initializePatientHeightAndWeight(), isNewPatient: this.isNewPatient, isEligible: this.isEligible, facilityOrderPatient: this.facilityOrderPatient, checkIsEmpty: (isReview) => this.checkIsEmpty(isReview), getNumberOfTemplates: () => this.getNumberOfTemplates(), isImportAllowed: this.isImportAllowed, diagnosisCode: this.lookups.diagnosisCode, pageViewStore: this.pageViewStore })
        );

        this.disabledPatient = false;

        if (this.facilityOrderTemplateStores && this.facilityOrderTemplateStores.length === 0) {
            this.facilityOrderTemplateStores = undefined;
        }
        this.checkIsEmpty(isReview);
    }

    @action.bound
    async openInsuranceInformation() {
        window.open(`${this.rootStore.applicationStore.app.baasic.settings.brightreeBaseUrl}Patient/frmPatientInsuranceRO.aspx?PatientKey=${this.patient.patientKey}&Edit=0`);
    }

    @action.bound
    async changeFacilityOrderPatientNote(note) {
        this.facilityOrderPatientNote = note;
    }

    @action.bound
    async updateFacilityOrderPatientNote() {
        this.facilityOrderPatient.note = this.facilityOrderPatientNote;
        await this.pageViewStore.facilityOrderPatientService.update(this.facilityOrderPatient);
        this.changeFacilityOrderPatientInsuranceStatus();
    }

    @action.bound
    async updateFacilityOrderPatient(isInsuranceInfo = false) {
        if (isInsuranceInfo) {
            this.facilityOrderPatient.insuranceInfo = this.insuranceInfo;
        }
        await this.pageViewStore.facilityOrderPatientService.update(this.facilityOrderPatient);
        if (isInsuranceInfo) {
            // Reload the facility order patient so the backend-recomputed "Non-Billable Insurance" eligibility
            // status note is displayed after the Insurance Info Note is saved.
            await this.initializePatient(true);
        }
    }

    @action.bound
    async reviewFacilityOrderTemplate(id) {
        var store = this.facilityOrderTemplateStores.find(t => t.id === id);
        if ((this.selectedStatusAbrv === "in-progress" && store.facilityOrderTemplate.isClinicalReviewed) ||
            (this.selectedStatusAbrv === "reviewed-clinical" && !store.facilityOrderTemplate.isClinicalReviewed)) {
            var index = this.facilityOrderTemplateStores.findIndex(t => t.id === id);
            this.facilityOrderTemplateStores.splice(index, 1);
        }

        if (this.facilityOrderTemplateStores && this.facilityOrderTemplateStores.length === 0) {
            this.facilityOrderTemplateStores = undefined;
        }

        this.checkIsEmpty(true);
    }

    @action.bound
    async openFacilityOrderTemplateNewFlowInsuranceHistoryOfChangesModal() {
         this.pageViewStore.facilityOrderTemplateNewFlowInsuranceHistoryOfChangesModal.open({
            patient: this.patient,
            facilityOrderTemplates: this.items,
            facilityOrderPatient: this.facilityOrderPatient
        });
    }

    @action.bound
    changeInsuranceInfo(insuranceInfo) {
        this.insuranceInfo = insuranceInfo;
    }

    @action.bound
    async openFacilityOrderTemplateNewFlowUSIntakeInsuranceQuestionModal() {
        this.pageViewStore.facilityOrderTemplateNewFlowUSIntakeInsuranceQuestionModal.open({
            patient: this.patient,
            facilityOrderPatient: this.facilityOrderPatient
        });
    }

    @action.bound
    async openFacilityOrderPatientNewFlowInsuranceEditModal() {
        this.pageViewStore.facilityOrderPatientNewFlowInsuranceEditModal.open({
            patient: this.patient,
            // Reload the local patient (insurance) and the facility order patient so the backend-recomputed
            // "No OON Benefits" eligibility status note is displayed after the primary active insurance changes.
            refreshInsuranceData: async () => {
                await this.fetchPatient();
                await this.initializePatient(true);
            },
            changeFacilityOrderPatientInsuranceStatus: () => this.changeFacilityOrderPatientInsuranceStatus(),
            facilityOrderPatient: this.facilityOrderPatient,
            facilityOrderTemplates: this.items
        });
    }

    @action.bound
    async openFacilityOrderPatientNewFlowUSIntakeInsuranceInfoModal() {
        this.pageViewStore.facilityOrderPatientNewFlowUSIntakeInsuranceInfoModal.open({
            facilityOrderPatient: this.facilityOrderPatient,
            updateFacilityOrderPatient: () => this.updateFacilityOrderPatient(),
            changeInsuranceInfo: async (insuranceInfo) => {
                this.changeInsuranceInfo(insuranceInfo);
                // Reload the facility order patient so the backend-recomputed "Non-Billable Insurance" eligibility
                // status note is displayed after the modal saves the Insurance Info Note.
                await this.initializePatient(true);
            }
        });
    }

    @action.bound
    async openFacilityOrderPatientNewFlowUSIntakeEligibilityStatusNoteModal() {
        this.pageViewStore.facilityOrderPatientNewFlowUSIntakeEligibilityStatusNoteModal.open({
            facilityOrderPatient: this.facilityOrderPatient
        });
    }

    @action.bound
    async openFacilityOrderPatientNewFlowInsuranceNoteModal(newFlowStatusAbrv, isStatus = false) {
        this.pageViewStore.facilityOrderPatientNewFlowInsuranceNoteModal.open({
            facilityOrderPatient: this.facilityOrderPatient,
            facilityOrderId: this.facilityOrder.id,
            patient: this.patient,
            facilityOrderTemplates: this.items,
            setNewFlowStatus: async (changeFacilityOrderTemplateStatus, eligibleChange) => await this.setNewFlowStatus(newFlowStatusAbrv, null, false, null, isStatus ? "insurance" : null, false, true, true, changeFacilityOrderTemplateStatus, eligibleChange),
            // Reload the local patient (insurance) and the facility order patient so the backend-recomputed
            // "No OON Benefits" eligibility status note is displayed after the primary active insurance changes.
            refreshInsuranceData: async () => {
                await this.fetchPatient();
                await this.initializePatient(true);
            },
            fetchPatientTemplates: async () => await this.fetchPatientTemplates()
        });
    }

    @action.bound
    openExtraSuppliesApprovalRequiredModal(master) {
        if (master && this.facilityOrder.facility.corporate_ && this.facilityOrder.facility.corporate_.approvalRequiredExtraSupplies) {
            this.pageViewStore.extraSuppliesApprovalRequiredModal.onConfirm = async () => { this.pageViewStore.extraSuppliesApprovalRequiredModal.close(); await this.openCreateFacilityOrderTemplateUSIntakeNewFlowModal(); };

            this.pageViewStore.extraSuppliesApprovalRequiredModal.open({
                question: 'MODAL.QUESTION_EXTRA_SUPPLIES_APPROVAL'
            });
        }
        else {
            this.openCreateFacilityOrderTemplateUSIntakeNewFlowModal();
        }
    }

    @action.bound
    async openCreateFacilityOrderTemplateUSIntakeNewFlowModal() {
        const inactiveOption = this.getSelectedInactiveOption("insurance");
        const newFlowInsuranceStatusId = inactiveOption == "success" ? this.lookups.newFlowStatus.find((s) => s.abrv === "no-change").id : inactiveOption == "change" ? this.lookups.newFlowStatus.find((s) => s.abrv === "change").id : null;
        await this.pageViewStore.createFacilityOrderTemplateUSIntakeNewFlowModal.open({
            facilityOrderId: this.facilityOrder.id,
            patientId: this.patient.id,
            patientKey: this.patient.patientKey,
            patient: this.patient,
            facilityOrder: this.facilityOrder,
            newFlowInsuranceStatusId: newFlowInsuranceStatusId,
            isReviewed: true,
            isClinicalReviewed: (!this.facilityOrderPatient.eligibilityStatus || (this.facilityOrderPatient.eligibilityStatus && this.facilityOrderPatient.eligibilityStatus.name !== "Eligible")),
            fetchPatientTemplates: async () => await this.fetchPatientTemplates()
        });
    }

    @action.bound
    removeTemplate(facilityOrderTemplateId) {
        this.facilityOrderTemplateStores.splice(this.facilityOrderTemplateStores.indexOf(this.facilityOrderTemplateStores.find((i) => i.id === facilityOrderTemplateId)), 1);
        this.items.splice(this.items.indexOf(this.items.find((i) => i.id === facilityOrderTemplateId)), 1);
        this.checkIsEmpty(this.facilityOrderPatient.isNewPatient);
    }

    @action.bound
    async setLinkedTemplate(facilityOrderTemplateId) {
        if (this.items.find(i => i.id === facilityOrderTemplateId)) {
            this.items.find(i => i.id === facilityOrderTemplateId).linkedTemplateId = null;
        }
    }

    @action.bound
    async setNewFlowStatus(
        statusAbrv,
        templateId,
        isReview = false,
        inactiveOptionId = null,
        role = null,
        unreview = false,
        setInactiveReasonAndStatuses = false,
        changeFacilityOrderPatientInsuranceStatus = false,
        changeFacilityOrderTemplateStatus = false,
        eligibleChange = false
    ) {
        try {
            if(!this.items)
                return;

            const status = this.lookups.newFlowStatus.find((s) => s.abrv === statusAbrv);
            let updateItems = this.items.filter((item) => !templateId || item.id === templateId);

            const updatedItems = _.map(updateItems, (item) => {
                return {
                    id: item.id,
                    inactiveReasonId: statusAbrv === "discharge" && templateId ? 58 : inactiveOptionId != null ? inactiveOptionId : item.inactiveReasonId,
                    isReviewed: unreview ? false : isReview && templateId ? isReview : isReview ? item.newFlowUSIntakeStatus.abrv === "no-change" ? true : false : item.isReviewed,
                    newFlowStatusId: statusAbrv === "reviewed-clinical" || role == "insurance" || unreview ? item.newFlowStatusId : status.id,
                    newFlowStatusUpdatedByUserId: this.rootStore.userStore.user.id,
                    newFlowInsuranceStatusId: statusAbrv === "discharge" ? status.id : statusAbrv === "reviewed-clinical" || role == "intake" || templateId ? item.newFlowInsuranceStatusId : status.id,
                    portalNote: item.portalNote,
                    setInitialEligibility: item.setInitialEligibility,
                    newFlowUSIntakeStatusId: unreview ? item.newFlowStatusId : role === "insurance" ? item.newFlowUSIntakeStatusId : isReview && !templateId ? item.newFlowUSIntakeStatus.abrv === "no-change" ? status.id : item.newFlowUSIntakeStatusId : status.id,
                    setInactiveReason: setInactiveReasonAndStatuses,
                    isTemplateStatus: templateId ? true : false,
                    setStatuses: setInactiveReasonAndStatuses && !templateId ? true : false
                };
            });

            await this.pageViewStore.facilityOrderTemplateService.batchUpdate(updatedItems);

            if(changeFacilityOrderPatientInsuranceStatus){
                await this.pageViewStore.facilityOrderPatientService.changeFacilityOrderPatientInsuranceStatus({id:this.facilityOrderPatient.id });
            }

            if(changeFacilityOrderTemplateStatus){
                await this.pageViewStore.facilityOrderTemplateService.changeTemplateStatus(updateItems.map(item => item.id));
            }

            if (isReview) {
                const temp = updatedItems.filter(i => i.isReviewed);
                this.items = this.items.filter(i => !temp || !temp.some(t => t.id == i.id))
            }
            else if (unreview) {
                this.items = this.items.filter(i => i.id != templateId || !updatedItems.some(t => t.id == i.id))
            }
            else {
                await this.fetchPatientTemplates();
            }
            this.checkIsEmpty((eligibleChange || (setInactiveReasonAndStatuses && !templateId)) ? true : false);
        } catch (err) {
            this.rootStore.notificationStore.error("An unexpected error occurred while trying to update the template.", err);
        }
    }

    @action.bound
    getPatientStatusButtonClassName(inactiveOptionId = null) {
        this.inactiveOptionStoreId = "";

        this.inactiveOptions
            .filter((i) => !inactiveOptionId || i.id === inactiveOptionId)
            .forEach((item) => {
                if (this.selectedStatusAbrv === "in-progress") {
                    if (item.name === "Hospital" && this.facilityOrderPatient.activeStatus === 'Hospital') {
                        this.hospitalClassName = "is-active--alt";
                    }
                    else if (item.name === "Active" && this.facilityOrderPatient.activeStatus !== 'Hospital') {
                        this.inactiveOptionStoreId = "0";
                    }
                }
                else if (this.selectedStatusAbrv === "discharge") {
                    if (item.name === "Hospital" && this.facilityOrderPatient.activeStatus === "Hospital") {
                        this.inactiveOptionStoreId = "15";
                    }
                    else if (item.name === "Discharged" && this.facilityOrderPatient.activeStatus === "Discharged") {
                        this.inactiveOptionStoreId = "17";
                    }
                    else if (item.name === "Expired" && this.facilityOrderPatient.activeStatus === "Expired") {
                        this.inactiveOptionStoreId = "18";
                    }
                    else if (item.name === "Active" && this.facilityOrderPatient.activeStatus !== "Hospital" && this.facilityOrderPatient.activeStatus !== "Discharged" && this.facilityOrderPatient.activeStatus !== "Expired") {
                        this.inactiveOptionStoreId = "0";
                    }
                }
                else if (this.selectedStatusAbrv === "reviewed-clinical") {
                    if (item.name === "Active") {
                        this.inactiveOptionStoreId = "0";
                    }
                }
            });
    }

    @action.bound
    async setInactiveOption(newFlowStatusAbrv, inactiveOptionId, setInactiveReasonAndStatuses) {
        _.each(this.items, (item) => {
            item.inactiveReasonId = inactiveOptionId;
            item.inactiveReason = this.inactiveOptions.find((i) => i.id === inactiveOptionId).name;
        });
        this.getPatientStatusButtonClassName(inactiveOptionId);
        await this.setNewFlowStatus(newFlowStatusAbrv, null, false, inactiveOptionId, null, false, setInactiveReasonAndStatuses);
    }

    @action.bound
    async openFacilityOrderTemplateItemNewFlowActivatePatientModal(inactiveOptionId, setInactiveReasonAndStatuses = false) {
        this.disabledPatient = true;
        if (inactiveOptionId === "0") {
            const facilityOrderUSIntakeStatus = this.facilityOrder && this.facilityOrder.facilityOrderStatuses && this.facilityOrder.facilityOrderStatuses.find(i => i.status.abrv === 'us-intake');
            if(facilityOrderUSIntakeStatus && facilityOrderUSIntakeStatus.completedOn){
                await this.activatePatient();
            }
            else{
                await this.setPatientStatus(inactiveOptionId === "15" ? "Hospital" : inactiveOptionId === "17" ? "Discharged" : inactiveOptionId === "18" ? "Expired" : "Active");
                await this.setInactiveOption("in-progress", inactiveOptionId, setInactiveReasonAndStatuses);
            }
        } else {
            await this.setPatientStatus(inactiveOptionId === "15" ? "Hospital" : inactiveOptionId === "17" ? "Discharged" : inactiveOptionId === "18" ? "Expired" : "Active");
            await this.setInactiveOption("discharge", inactiveOptionId, setInactiveReasonAndStatuses);
        }
        this.disabledPatient = false;
    }

    @action.bound
    async setInsuranceStatus(newFlowStatusAbrv, isStatus = false) {
        this.disabledPatient = true;
        if (newFlowStatusAbrv === "no-change") {
            await this.setNewFlowStatus(newFlowStatusAbrv, null, false, null, "insurance");
        } else if (newFlowStatusAbrv === "change") {
            await this.openFacilityOrderPatientNewFlowInsuranceNoteModal(newFlowStatusAbrv, isStatus);
        }
        this.disabledPatient = false;
    }

    @action.bound
    getSelectedInactiveOption(option, facilityOrderTemplate) {
        if (option === "intake") {
            if (facilityOrderTemplate.newFlowStatus.abrv === "change") {
                return "warning-triangle";
            }
            else if (facilityOrderTemplate.newFlowStatus.abrv === "no-change") {
                return "success";
            }
            else if (facilityOrderTemplate.newFlowStatus.abrv === "discharge" && this.items) {
                return "danger";
            }
        }
        else if (option === "insurance") {
            if (this.items && this.items.every((x) => x.newFlowInsuranceStatus && x.newFlowInsuranceStatus.abrv === "no-change")) {
                return "success";
            }
            else if (this.items && this.items.every((x) => x.newFlowInsuranceStatus && x.newFlowInsuranceStatus.abrv === "change")) {
                return "change";
            }
        }
        else if (option === "us-intake") {
            if (!facilityOrderTemplate.templateId && (facilityOrderTemplate.inactiveReasonId != 15 && facilityOrderTemplate.inactiveReasonId != 17 && facilityOrderTemplate.inactiveReasonId != 18)) {
                return "new";
            }
            else if (facilityOrderTemplate.newFlowStatus.abrv === "change") {
                return "warning-triangle";
            }
            else if (facilityOrderTemplate.newFlowStatus.abrv === "no-change") {
                return "success";
            }
            else if (facilityOrderTemplate.newFlowStatus.abrv === "discharge" && this.items) {
                return "danger";
            }
        }
        return "";
    }

    async changeFacilityOrderPatientInsuranceStatus() {
        if (this.selectedStatusAbrv !== "discharge" && !this.facilityOrderPatient.isNewPatient) {
            let response = await this.pageViewStore.facilityOrderPatientService.changeFacilityOrderPatientInsuranceStatus({id:this.facilityOrderPatient.id });
            if (response && response.data && response.data.item && this.items.length > 0) {
                for (const item of response.data.item) {
                    if (this.items.find(x => x.id === item.id)) {
                        this.items.find(x => x.id === item.id).newFlowInsuranceStatusId = item.newFlowInsuranceStatusId;
                        this.items.find(x => x.id === item.id).newFlowInsuranceStatus = this.lookups.newFlowStatus.find((s) => s.id === item.newFlowInsuranceStatusId);
                    }
                }
                const temp = this.items;
                this.items = null;
                this.items = temp;
            }
        }
    }

    @action.bound
    async activatePatient() {
        if (this.facilityOrderPatient.eligibilityStatusId && this.facilityOrderPatient.isReviewed ) {
            await this.pageViewStore.facilityOrderTemplateService.activateFacilityOrderTemplate({facilityOrderPatientId: this.facilityOrderPatient.id, eligibilityStatusId: this.facilityOrderPatient.eligibilityStatusId });
            await this.setPatientStatus("Active");
            await this.fetchPatientTemplates();
        }
        else {
            await this.openFacilityOrderTemplateNewFlowUSIntakePatientActivationModal();
        }
    }

    @action.bound
    async openFacilityOrderTemplateNewFlowUSIntakePatientActivationModal() {
        this.pageViewStore.facilityOrderTemplateNewFlowUSIntakeTemplateActivationModal.open({
            facilityOrderPatient: this.facilityOrderPatient,
            patient: this.patient,
            fetchPatientTemplates: () => this.fetchPatientTemplates(),
            setPatientStatus: async () => await this.setPatientStatus("Active")
        });
    }

    @action.bound
    async setPatientStatus(status) {
		this.facilityOrderPatient.activeStatus = status;
		await this.pageViewStore.facilityOrderPatientService.update(this.facilityOrderPatient);
	}

    @action.bound
    showPreviousFlag() {
		return this.facilityOrderPatient && this.facilityOrderPatient.facilityOrderPatientInitial && (this.facilityOrderPatient.activeStatus != this.facilityOrderPatient.facilityOrderPatientInitial.activeStatus);
	}

    @action.bound
    getNumberOfTemplates() {
		return this.facilityOrderTemplateStores.length;
	}

    @action.bound
    async importFacilityOrderTemplates() {
        let params = {
            facilityOrderId: this.facilityOrder.id,
            patientId: this.patient.id,
            fields: "importDetailStatusId,importDetailStatus,isClinicalReviewed,inactiveReasonId",
            embed:"importDetailStatus",
            rpp: 1000
        }

        if (this.facilityOrder.isEnteralWeek) {
            params = _.extend(params, {
                itemCategoryIds: [this.enteralItemCategoryId]
            });
        }
        const facilityOrderTemplates = await this.pageViewStore.facilityOrderTemplateService.find(params);
        // if (facilityOrderTemplates && facilityOrderTemplates.data && facilityOrderTemplates.data.item && !facilityOrderTemplates.data.item.some(i => i.isClinicalReviewed === true && i.importDetailStatus.abrv === 'new' && (!this.facilityOrderPatient.isNewPatient || (this.facilityOrderPatient.isNewPatient && i.inactiveReasonId !== 17 && i.inactiveReasonId !== 18)))) {
        //     this.rootStore.notificationStore.error("This patient doesn't have at least one template that can be imported.");
        //     return;
        // }

        // var response = await this.pageViewStore.facilityOrderTemplateService.isReviewedFacilityOrderNewFlowAsync({ facilityOrderId: this.facilityOrder.id });
        // this.pageViewStore.importFacilityOrderConfirmModal.onConfirm = async () => { this.pageViewStore.importFacilityOrderConfirmModal.close(); await this.importFacilityOrderNewFlow(); };
        // this.pageViewStore.importFacilityOrderConfirmModal.open({
        //     message: response.data ? 'FACILITY_ORDER_TEMPLATE.EDIT.CONFIRM_IMPORT' : 'FACILITY_ORDER_TEMPLATE.EDIT.CONFIRM_NOT_REVIEWED'
        // });

        if (facilityOrderTemplates && facilityOrderTemplates.data && facilityOrderTemplates.data.item && !facilityOrderTemplates.data.item.some(i => i.importDetailStatus.abrv === 'new')) {
            this.rootStore.notificationStore.error("This patient doesn't have at least one template that can be imported.");
            return;
        }

        if (facilityOrderTemplates && facilityOrderTemplates.data && facilityOrderTemplates.data.item && facilityOrderTemplates.data.item.some(i => !i.isClinicalReviewed && i.importDetailStatus.abrv === 'new')) {
            this.rootStore.notificationStore.error("The Import cannot be started before all templates are clinically reviewed.");
            return;
        }

        this.pageViewStore.importFacilityOrderConfirmModal.onConfirm = async () => { this.pageViewStore.importFacilityOrderConfirmModal.close(); await this.importFacilityOrderNewFlow(); };
        await this.pageViewStore.importFacilityOrderConfirmModal.open({
            message: 'FACILITY_ORDER_TEMPLATE.EDIT.CONFIRM_IMPORT'
        });
    }

    async importFacilityOrderNewFlow(){
        try{
            this.rootStore.notificationStore.success("Importing template(s) to Brightree is in progress.");
            await this.pageViewStore.facilityOrderService.importFacilityOrderNewFlow({
                facilityOrderId: this.facilityOrder.id,
                patientId: this.patient.id
            });
        }
        catch (err) {
            err.data.errors == "There are no templates to import to BT." ? this.rootStore.notificationStore.success(err.data.errors) : this.rootStore.notificationStore.error(err.data.errors);
        }
    }
}

export default FacilityOrderPatientNewFlowClinicalEditViewStore;
